export default __webpack_public_path__ + "static/media/node.a4713ff2.png";